/**
 * Describes which slice of the results a page is showing, e.g. "26-50 of 118
 * results". `shown` is the row count on this page, not the page size.
 */
export function formatResultRange(
  offset: number,
  shown: number,
  total: number,
): string {
  if (total === 0 || shown === 0) {
    return "0 results";
  }
  const first = offset + 1;
  const last = offset + shown;
  return `${first.toString()}-${last.toString()} of ${total.toString()} ${
    total === 1 ? "result" : "results"
  }`;
}

/**
 * The offset one page back, clamped: the caller may still be on a page whose
 * offset is smaller than a full page, and a negative offset is not a request
 * the API can answer.
 */
export function previousOffset(offset: number, limit: number): number {
  return Math.max(0, offset - limit);
}
